export default __webpack_public_path__ + "static/media/6.17ab54d2.webp";